import React, { Component, useState } from 'react';
import { connect } from 'react-redux';
import api from '../../../axios-local-api';
import Box from '../../../hoc/Box/Box';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import classes from './SpeedCheckResult.css';
import { Bar } from 'react-chartjs-2';
import moment from 'moment';

const SpeedCheckResult = (props) => {

  const getLatestDateRecord = (records) => {
    if (records === null)
      return [];

    let recordsByDate = {};
    records.forEach((record) => {
      // Access record.timestamp which is the same name in the new structure
      const date = moment(record.timestamp).format('YYYY-MM-DD');
      if (recordsByDate[date]) {
        recordsByDate[date].push(record);
      } else {
        recordsByDate[date] = [record];
      }
    })
    // ... rest of getLatestDateRecord remains the same as it just sorts and filters records
    let latestRecords = [];
    let lastDateToDisplay = moment().subtract(13,'days').format('YYYY-MM-DD');
    Object.keys(recordsByDate).forEach((key) => {
      if (key >= lastDateToDisplay) {
        recordsByDate[key].sort((a, b) => {
          return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
        })
        Object.keys(recordsByDate[key]).forEach(k => {
          if (k == 0) {
            latestRecords.push(recordsByDate[key][k]);
          }
        })
      }

    })

    return latestRecords;
  }

  const formatDataSet = (data) => {
    const displayDates = [];
    // If data[0] doesn't exist, this might throw an error if the initial props are empty.
    // Ensure you have default handling for empty 'data' array.
    if (!data || data.length === 0) {
        return { uploadSpeeds: [], downloadSpeeds: [], serverNames: [], serverIds: [] };
    }

    for(var i= 0; i < 14; i++){
      let date = moment(data[0].timestamp).subtract(i,'days').format('YYYY-MM-DD'); 
      displayDates.push(date);      
    }    
    let latestSpeeds = getLatestDateRecord(data);
    
    if(latestSpeeds.length < 14){
      const availableDates = [];
      latestSpeeds.forEach(element => {
        availableDates.push(moment(element.timestamp).format('YYYY-MM-DD'));          
      });
      const unavailableDate = displayDates.filter(e=>!availableDates.includes(e));
    
      unavailableDate.forEach(date => {       
       // Add default values for all potential fields, especially the new ones if they don't exist
       // Note: 'up' is missing from the provided JSON sample, so setting a default of 0 is critical.
       latestSpeeds.push({ 
           down: 0, 
           up: 0, // Default for 'up'
           timestamp: moment(date , 'YYYY-MM-DD').valueOf(), 
           serverName: 'N/A', 
           serverId: 'N/A',
           value: 0 // Default for 'value' from new structure
        });          
      });      
    }
    
    let formattedDataSet = {
      'uploadSpeeds': [],
      'downloadSpeeds': [],
      'serverNames': [], // New list for server names
      'serverIds': []    // New list for server IDs
    };

    latestSpeeds.forEach(element => {

      // Map 'up' field (might be missing in new data structure, defaults to 0)
      let upItem = {
        x: moment(element.timestamp).format('YYYY-MM-DD'),
        y: (element.up || 0).toFixed(2) // Use 0 if element.up is undefined
      }
      formattedDataSet['uploadSpeeds'].push(upItem);

      // Map 'down' or 'value' field from the input
      let downSpeedValue = element.down !== undefined ? element.down : element.value;

      let downItem = {
        x: moment(element.timestamp).format('YYYY-MM-DD'),
        y: (downSpeedValue || 0).toFixed(2) // Use 0 if value is undefined
      }
      formattedDataSet['downloadSpeeds'].push(downItem);
      
      // MAP NEW FIELDS HERE
      let serverNameItem = {
          x: moment(element.timestamp).format('YYYY-MM-DD'),
          y: element.serverName || 'N/A'
      };
      formattedDataSet['serverNames'].push(serverNameItem);

      let serverIdItem = {
        x: moment(element.timestamp).format('YYYY-MM-DD'),
        y: element.serverId || 'unknown'
      };
      formattedDataSet['serverIds'].push(serverIdItem);

    });
    
    return formattedDataSet;
  }

  const speeds = formatDataSet(props.speedCheckResults);
  const uploadSpeeds = speeds ? speeds['uploadSpeeds'] : [];
  const downloadSpeeds = speeds ? speeds['downloadSpeeds'] : [];
  const serverNames = speeds ? speeds['serverNames'] : []; // Access new data
  const serverIds = speeds ? speeds['serverIds'] : [];     // Access new data
  
  // console.log('serverNames :::::', serverNames);
  
  let displayData = true;
  if(uploadSpeeds.length === 0 && downloadSpeeds.length === 0){
    displayData = false;
  }
  
  return (
    <Box>
      <div className={classes.RouterSpeedCheck}>
        <div className={classes.TitleArea}>
          <div className={classes.TitleLeft}>
            <h3 id = 'HistoricalCheck' className={classes.ComponentTitle}>Historical Speed Check Result</h3>
          </div>
          {
           displayData ?
           <div className={classes.TitleRight}>
            <span id = 'Last14' style={{ fontWeight: 'bold' }}> Last 14 days</span>
          </div> : ''
          }          
        </div>
        <div >
        {
           !displayData ?
           <div className={classes.speedCheckResultsMsg}>No Data within the last 14 days</div>
           :
          <Bar
            // ... (rest of the Bar chart configuration is the same)
            data={{
              labels: [
                moment()
                .subtract(1, 'days')
                .format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD')
              ],
              datasets: [
                {
                  type: 'bar',
                  label: 'Download',
                  data: downloadSpeeds,
                  backgroundColor: 'skyblue',
                  borderWidth: 0.5,
                },
                {
                  type: 'bar',
                  label: 'Upload',
                  data: uploadSpeeds,
                  backgroundColor: 'darkblue',
                  borderWidth: 0.5,
                }
              ],
            }}
            height={300}
            width={700}
            options={{
             // ... (scales, legend, tooltips options are the same)
             maintainAspectRatio: false,
              scales: {
                xAxes: [
                  {
                    offset:true,
                    type: 'time',
                    bounds: 'ticks',                 
                    gridLines: {
                      display: false
                    },
                    ticks: {
                      maxTicksLimit: 13,
                      stepSize: 1,
                      source: 'data'
                    },
                    
                  }
                ],
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                      callback: function(label) {
                        return label +'Mb';
                      },
                      stepSize: 20
                    },
                  },
                ],
              },
              legend: {
                labels: {
                  fontSize: 15,
                  pointStyle: 'circle',
                  usePointStyle: true,
                  padding: 25     
                },              
              },
              tooltips: {
                enabled:props.isDesktop,
                callbacks: {
                  title: function(tooltipItem, data) {
                    // Tooltip logic might need adjustment if you want to display server name/id here
                    // tooltipItem[0].yLabel = tooltipItem[0].yLabel + ' Mbps';
                    // tooltipItem[0].value = tooltipItem[0].value + ' Mbps';
                  }
                }
              }
            }}
          />
        }
        </div>
      </div>
    </Box>
)
        }

const mapStateToProps = (state) => ({
  speedCheckResults: state.speedCheck.speedCheckResults,
})

export default connect(mapStateToProps, null)(withErrorHandler(SpeedCheckResult, api));
